/**
 * Shared constants for the buyer/distributor ENTITY search inputs in the
 * create-chat flow. Entity searches hit the global search index, so they only
 * fire from the third character; user searches are scoped and small and may
 * fire from the first character.
 */
export const ENTITY_SEARCH_MIN_CHARS = 3;

export const ENTITY_SEARCH_MIN_CHARS_HINT =
  'Type at least 3 characters to search';
